import { HostPlatform, HostSystem } from '@ftr/contracts/regional-api'
import { AbstractClassBuilder } from '@ftr/foundation'
import { HostCpuBuilder } from './HostCpuBuilder'
import { HostHardwareBuilder } from './HostHardwareBuilder'
import { HostMemoryBuilder } from './HostMemoryBuilder'
import { HostOsBuilder } from './HostOsBuilder'
import { HostStorageBuilder } from './HostStorageBuilder'

export class HostSystemBuilder extends AbstractClassBuilder<HostSystem> {
  constructor(platform: HostPlatform) {
    super(HostSystem, {
      hw: new HostHardwareBuilder(platform).build(),
      os: new HostOsBuilder(platform).build(),
      cpu: new HostCpuBuilder(platform).build(),
      storage: new HostStorageBuilder().build(),
      memory: new HostMemoryBuilder().build(),
    })
  }
}
